import { observable, autorun, action, computed, toJS } from 'mobx'
import { InformfixService } from '../services'
class InformStore {
  @observable sidebarItems = []
  @observable inform = {}
  @observable items = []
  @observable itemsPending = []
  @observable home = {}
  @observable editId = null
  @observable itemGallery = [] // ใช้เวลาแก้ไขหรือดู
  @observable itemJob = [] // ใช้เวลาแก้ไขหรือดู
  @observable page = 1
  @observable job = {}
  @observable showModalCancel = false

  @observable jobGallery = []

  //นับสถานะต่าง ๆ

  @observable countNewInform = 0 //  จำนวนใบแจ้งซ่อมที่แจ้งเข้ามาใหม่และยังไม่ได้จัดคิว
  @observable countNewJob = 0 //  จำนวนคิวงานซ่อมทั้งหมดที่ยังไม่ปิดงาน
  @observable countPostpone = 0 //  จำนวนใบแจ้งซ่อมเลือนนัดหมาย
  @observable count4task = 0 // จำนวนใบแจ้งซ่อมรอจัดคิวนัดหมาย
  @observable countWorkstatus = []
  @observable countProcess = {}

  constructor() {
    autorun(() => {})
  }

  @computed get getItem() {
    return this.inform ? toJS(this.inform) : {}
  }
  @computed get getItems() {
    return this.items ? toJS(this.items) : []
  }
  @computed get getItemsPending() {
    return this.itemsPending ? toJS(this.itemsPending) : []
  }

  @computed get getJob() {
    return this.job ? toJS(this.job) : {}
  }
  @computed get getGalleryItems() {
    return this.itemGallery ? toJS(this.itemGallery) : []
  }
  @computed get getJobItems() {
    return this.itemJob ? toJS(this.itemJob) : []
  }
  @computed get getJobGallery() {
    return this.jobGallery ? toJS(this.jobGallery) : []
  }
  @computed get getSidebarItems() {
    return this.sidebarItems ? toJS(this.sidebarItems) : []
  }

  @action
  setItem = (data) => {
    this.inform = data
  }
  @action
  setEditId = (id) => {
    this.editId = id
  }

  @action
  setItems = (data) => {
    this.items = data
  }
  @action
  setItemsPending = (data) => {
    this.itemsPending = data
  }
  @action
  setGalleryItems = (data) => {
    this.itemGallery = data
  }
  @action
  setJobItems = (data) => {
    this.itemJob = data
  }
  @action
  setHome = (data) => {
    this.home = data
  }

  @action setPage = (number) => {
    this.page = number
  }

  @action setJob = (job) => {
    this.job = job
  }

  @action setCountWorkstatus = (data) => {
    this.countWorkstatus = data
  }
  @action setCountPostpone = (number) => {
    this.countPostpone = number
  }

  @action setCount4task = (number) => {
    this.count4task = number
  }

  @action setJobGallery(images) {
    return this.jobGallery ? toJS(this.jobGallery) : []
  }
  @action setSidebarItems(data) {
    return (this.sidebarItems = toJS(data))
  }
}

export default new InformStore()
